import { DeleteOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { GridRenderCellParams, GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';

import { UseDataEditGridConfigConfig } from '~/components/DataGridCustom';

export interface DeleteActionCellProps<R extends GridValidRowModel> extends GridRenderCellParams<R> {
  onClick: UseDataEditGridConfigConfig['onRowDelete'];
  disabled?: boolean;
}

export const DeleteActionCell = <R extends GridValidRowModel & { id: GridRowId } = { id: GridRowId }>({
  row,
  onClick,
  disabled,
}: DeleteActionCellProps<R>) => (
  <IconButton disabled={disabled} onClick={() => onClick?.(row.id)}>
    <DeleteOutlined />
  </IconButton>
);
